import { createAction } from '@reduxjs/toolkit';

export const lexiconListActions = {
  navigateTo: createAction<{ navigateTo: string }>('LexiconList/NavigateTo'),
};
